import BossModel from "@/models/BossModel";
import Column from "@/models/WebsitePage/Version/Element/Row/Column/Column";
import Element from "@/models/WebsitePage/Version/Element/Element";

export default class Row extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-page/version/element/row';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePageVersionElementRows';

    static fields() {
		return {
			id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            element: this.hasOne(Element, 'website_page_version_element_row_id'),
            columns: this.hasMany(Column, 'website_page_version_element_row_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Columns() {
        return this.getRelated('columns');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Element() {
        return this.getRelated('element');
    }
}
